import axios from 'axios'

export default axios.create({
    baseURL: 'https://react-quiz-91f13.firebaseio.com/'
})